export const AUTH_REQUEST = "AUTH_REQUEST"
export const AUTH_LOGOUT = "AUTH_LOGOUT"